export const BodyShop = ({ children }) => {
  return (
    <div className="relative h-full">
      <div className=" block__ground_shop h-full xl:h-[100vh]">{children}</div>
    </div>
  )
}

export default BodyShop
